import React, { useRef } from "react";
import emailjs from "emailjs-com";

function Contact() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_6t9u6a6",
        "template_x16kh6k",
        form.current,
        "bj6fBeYtA0gwzS1Fm"
      )
      .then(
        (result) => {
          alert("Message sent successfully! 🚀");
        },
        (error) => {
          alert("Failed to send message ❌");
        }
      );
  };

  return (
    <section id="contact" className="py-5 min-vh-100 text-light">
      <div className="container">
        <h2 className="text-center fw-bold mb-5">
          📬 Get in <span className="text-info">Touch</span>
        </h2>

        <div className="row justify-content-center">
          <div className="col-md-8">
            <div className="card shadow-lg border-0 rounded-4" style={{ backgroundColor: "#161b22", color: "#c9d1d9" }}>
              <div className="card-body p-4">
                <form ref={form} onSubmit={sendEmail}>
                  
                  <div className="mb-3">
                    <label className="form-label text-info fw-semibold">Name</label>
                    <input type="text" name="user_name" className="form-control rounded-3 bg-transparent" placeholder="Enter your name"
                      style={{ border: "1px solid #30363d" }}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label text-info fw-semibold">Email</label>
                    <input type="email" name="user_email" className="form-control rounded-3 bg-transparent" placeholder="Enter your email"
                      style={{ border: "1px solid #30363d" }}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label text-info fw-semibold">Message</label>
                    <textarea rows="4" name="message" className="form-control rounded-3 bg-transparent" placeholder="Write your message..."
                      style={{ border: "1px solid #30363d" }}
                    ></textarea>
                  </div>

                  <div className="text-center">
                    <button type="submit" className="btn btn-info fw-bold px-4 rounded-3">
                      Send Message 🚀
                    </button>
                    <p style={{ padding: "5px" }}>
                      I am happy to work with you and your company. Consider me for requirements.
                    </p>
                  </div>

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
